import { alphabetGroup, SHORT_SCALE_SYMBOLS } from "./powerOfThousand.js";

/**
 * 단위 접미사 역파싱 (치트/수동 입력 흡수용). BigNumber에 의존하지 않고 (mantissa, 1000-base exponent)만 반환 —
 * BigNumber.fromString이 이 결과를 fromMantissaExp로 흡수한다 (순환 의존 회피).
 *
 * 범위 = ShortScale(대문자) + 알파벳(소문자 위주)만. 동양(만/억)·아랍·인도 단위 역파싱은 제외 —
 * phaser는 toString()이 e표기 직렬화 SSoT라 그 단위로 저장된 데이터가 없다(레퍼런스의 동양 역파싱은
 * 마이그레이션 전용). 호출부(fromString)는 e표기 정규식을 본 헬퍼보다 **먼저** 시도해 직렬화 경로를 보호한다.
 */

/**
 * ShortScale 단위 → 1000-base 지수. SHORT_SCALE_SYMBOLS(SSoT) 배열을 인덱스 기반으로 빌드 —
 * 21단위 목록을 powerOfThousand.ts 하나에만 정의하고 여기서 참조한다(이중 정의 방지).
 */
const SHORT_SCALE_PARSE: ReadonlyArray<readonly [string, number]> =
  SHORT_SCALE_SYMBOLS.map((sym, i) => [sym, i + 1] as const);

/**
 * `"1.5B"`/`"2.3aa"` 같은 단위 접미사 문자열 → { mantissa, exponent }(1000-base). 매칭 실패 시 null.
 * ShortScale(대문자) 우선, 그다음 알파벳(소문자/대문자 bijective). 숫자부가 유효한 finite일 때만 반환.
 */
export function parseUnitSuffix(trimmed: string): { mantissa: number; exponent: number } | null {
  const m = /^(-?\d*\.?\d+)\s*([A-Za-z]+)$/.exec(trimmed);
  if (!m) return null;
  const mantissa = Number(m[1]);
  if (!Number.isFinite(mantissa)) return null;
  const sym = m[2]!;
  const ss = SHORT_SCALE_PARSE.find(([unit]) => unit === sym);
  if (ss) return { mantissa, exponent: ss[1] };
  const g = alphabetGroup(sym);
  if (g !== null) return { mantissa, exponent: g };
  return null;
}
